import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatImage, formatUrl } from '@ifeng-fe/public_method';
import styles from './index.css';
import { classNames } from '../../../utils/classnames';
import { rel as relText } from '../../../utils/rel';
import { getGongyiData_v2 } from '../../../services/api';
import uniqBy from 'lodash/uniqBy';
// import { getFeedFlowList } from '../../../../common/api';

class NewsStream extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        loading: false,
        isEnd: this.props.content.isEnd,
        content: this.props.content.newsstream,
        pagination: {
            current: 3,
            pageSize: 6,
        },
    };

    listView(list = []) {
        const element = [];
        let group = [];

        for (let i = 0, j = list.length, k = j - 1; i < j; i++) {
            const item = list[i];

            if (!item) {
                continue;
            }
            // console.log(item);
            const url = formatUrl(item.url);

            group.push(
                <li key={i} className={styles.item + (i % 3 === 0 ? '' : ` ${styles.ml3}`)}>
                    <a className={styles.imageLink} href={url} target="_blank" rel={relText}>
                        <img src={formatImage(item.thumbnails, 330, 238)} alt={item.title} width={330} height={238} />
                    </a>
                    <p className={styles.link}>
                        <a href={url} title={item.title} target="_blank" rel={relText}>
                            {item.title}
                        </a>
                    </p>
                </li>,
            );

            if (i % 3 === 2 || i === k) {
                element.push(
                    <ul key={i} className={classNames(styles.group, 'clearfix')}>
                        {group}
                    </ul>,
                );
                group = [];
            }
        }

        return element;
    }
    // 加载更多
    handleGetMoreData = async () => {
        this.setState({ loading: true });

        try {
            const { columnId } = this.props.content;
            const { content } = this.state;
            const endItem = content[content.length - 1];
            const { pageSize } = this.state.pagination;

            const res = await getGongyiData_v2(columnId, this.state.pagination.current, this.state.pagination.pageSize);
            const { pageNumber, totalPage } = res;
            let data = res.data;

            console.log(res);

            // this.state.pagination.current = current + 1;
            this.setState({
                isEnd: pageNumber < totalPage ? 0 : 1,
                content: uniqBy(content.concat(data), 'id'),
                pagination: { current: pageNumber + 1, pageSize },
                loading: false,
            });
        } catch (err) {
            console.error(err);
            this.setState({ loading: false });
        }
    };
    render() {
        const { content, loading, isEnd } = this.state;

        return (
            <div className={styles.box}>
                <div className={styles.titleBox}>
                    <h4>精彩内容</h4>
                    <span className={styles.leftBg} />
                    <span className={styles.rightBg} />
                </div>
                {this.listView(content)}
                {isEnd ? null : (
                    <div className={styles.moreBox}>
                        <a className={styles.more} onClick={loading ? null : this.handleGetMoreData}>
                            {loading ? '加载中...' : ['浏览更多', <br key="br" />, '▼']}
                        </a>
                    </div>
                )}
            </div>
        );
    }
}

export default NewsStream;
